import { Alert, Heading, HFlow, Text, VFlow } from 'bold-ui'
import { ReactComponent as AtencaoDomiciliar } from 'images/side-menu/atencao-domiciliar.svg'
import { ReactComponent as GestaoMunicipal } from 'images/side-menu/gestao-municipal.svg'
import { ReactComponent as Relatorio } from 'images/side-menu/relatorios.svg'
import React from 'react'

import gifAbsenteismo from '../../images/novidades/gif_absenteismo.gif'
import gitAtencaoDomiciliar from '../../images/novidades/git_atencao_domiciliar.gif'
import rnds_contra_chave from '../../images/novidades/rnds_contra_chave.png'
import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalPanelV4_20() {
  if (!process.env.REACT_APP_VERSION) {
    return (
      <Alert type='danger' inline>
        Nenhuma informação sobre versões anteriores está disponível.
      </Alert>
    )
  }

  return (
    <VFlow>
      <VFlow vSpacing={1}>
        <Text fontWeight='bold'>Módulos com novidades:</Text>
        <HFlow hSpacing={5}>
          <VFlow vSpacing={0.2}>
            <Text component='li'>Gestão municipal</Text>
            <Text component='li'>Relatório gerencial de absenteísmo</Text>
            <Text component='li'>Atenção domiciliar</Text>
          </VFlow>
          <VFlow vSpacing={0.2}></VFlow>
        </HFlow>
        <NewsHeadingSection
          title='Gestão municipal'
          icon={<GestaoMunicipal style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              O módulo para Configuração de Compartilhamento de Prontuário foi descontinuado. Este módulo permitia que
              um município optasse por não compartilhar dados de prontuário com outros municípios da mesma instalação
              multimunicipal.
            </Text>
            <Text component='p'>
              A partir dessa versão, todos os municípios que utilizam a mesma instalação multimunicipal irão
              compartilhar os prontuário dos cidadãos.
            </Text>
            <Text component='p'>Esta alteração não interfere na geração de relatórios do PEC.</Text>A nova regra de
            compartilhamento de prontuário entre municípios está de acordo com a política de privacidade da RNDS.
            <Text component='p'></Text>
          </VFlow>

          <VFlow>
            <Heading level={4}>Configuração RNDS</Heading>
            <Text component='p'>
              O acesso à RNDS está com novidades. Foi inserido o campo "contra-chave" que possibilita o gestor municipal
              criar o certificado através do portal e-Gestor AB. Para habilitar o acesso à RNDS é necessário incluir o
              certificado, a senha do mesmo e a nova informação "identificador solicitante", obtida através do e-Gestor
              AB. Além disso, para as instalações que já possuem acesso à RNDS, é necessário reconfigurá-lo.
            </Text>
            <img src={rnds_contra_chave} style={{ width: '100%' }} alt='Imagem da nova tela de configuração da RNDS' />
          </VFlow>
        </NewsHeadingSection>
        <NewsHeadingSection
          title='Relatório gerencial de absenteísmo'
          icon={<Relatorio style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              Esta versão possui o novo grupo de Relatórios Gerenciais. Neste grupo, os dados são apresentados em uma
              tabela dinâmica construída pelo usuário. O usuário pode definir a tabela arrastando os campos disponíveis
              para linhas e colunas. Também é permitida a exportação destes relatórios para um arquivo no formado .csv.
            </Text>
            <Text component='p'>
              O primeiro relatório disponibilizado é o Relatório de Absenteísmo, o qual apresenta informações
              quantitativas sobre as faltas dos cidadãos.
            </Text>
            <img src={gifAbsenteismo} style={{ width: '100%' }} alt='Gif Relatório gerencial de absenteísmo' />
          </VFlow>
        </NewsHeadingSection>
        <NewsHeadingSection
          title='Atenção domiciliar'
          icon={<AtencaoDomiciliar style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              O módulo de atenção domiciliar foi redesenhado. As funcionalidades de lista AD, cadastro e relatório agora
              estão com um visual mais moderno e fácil de usar.
            </Text>
            <img src={gitAtencaoDomiciliar} style={{ width: '100%' }} alt='Gif Relatório gerencial de absenteísmo' />
          </VFlow>
        </NewsHeadingSection>
      </VFlow>
    </VFlow>
  )
}
